// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__MS6qM","highlighted":"RichText_highlighted__iyhc3","displayText":"RichText_displayText__Cft_r"};